import { mediaItems } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="mx-auto px-4 md:px-6 max-w-7xl">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-950 mb-3">
            精彩视频
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            暴走黑料在线观看与黑料社在线观看热门视频精选
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.map((item) => (
            <article
              key={item.id}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 transition-all duration-300 hover:border-primary-300 cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.thumbnail}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors"></div>
                <div className="absolute bottom-3 right-3 px-2.5 py-1 bg-black/70 text-background-50 text-xs font-medium rounded-md">
                  {item.duration}
                </div>
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-14 h-14 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50 transition-transform duration-300 group-hover:scale-110">
                  <i className="ri-play-fill text-2xl"></i>
                </div>
              </div>
              <div className="p-4">
                <span className="inline-block px-2.5 py-1 bg-primary-100 text-primary-700 text-xs font-semibold rounded-md mb-2">
                  {item.tag}
                </span>
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-950 mb-2 line-clamp-2 leading-snug">
                  {item.title}
                </h3>
                <div className="flex items-center gap-4 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line text-sm"></i>
                    {item.views}次观看
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}